import { AdminApiClient } from "../../api-client.js";
import { adminApiPath } from "../../api/index.js";
import type { AdminSessionResponse } from "./models.js";

export interface AdminAuthenticationApi {
  getSession(): Promise<AdminSessionResponse>;
  logout(): Promise<void>;
}

export function createAdminAuthenticationApi(client: AdminApiClient): AdminAuthenticationApi {
  return {
    getSession() {
      return client.request<AdminSessionResponse>({ path: adminApiPath("session") });
    },
    async logout() {
      await client.request<void>({
        method: "POST",
        path: adminApiPath("authLogout"),
        reason: "ADMIN_LOGOUT",
      });
    },
  };
}
